<div class="paginator-holder">
  <p-buttongroup class="paginator-buttons">
    <p-button
    [style]="{'minWidth': '40px', 'flex': '0', 'fontSize': '1.2rem'}"
    variant="outlined"
    severity="contrast"
      (click)="setPage(1)"
      [disabled]="disabled || pageCount < 0 || activePage < 2"
      [title]="'paginate_first_page'| translation"
    >
      <i class="fa-solid fa-backward"></i>
    </p-button>
    <p-button
      [style]="{'minWidth': '40px', 'flex': '0', 'fontSize': '1.2rem'}"
      variant="outlined"
      severity="contrast"
      (click)="setPage(activePage - 1)"
      [disabled]="disabled || activePage < 2"
      [title]="'paginate_previous_page'| translation"
    >
      <i class="fa-solid fa-caret-left"></i>
    </p-button>
    <p-button
    [style]="{'minWidth': '40px', 'flex': '0'}"
      *ngIf="activePage == pageCount && pageCount > 2"
      variant="outlined"
      severity="contrast"
      (click)="setPage(activePage - 2)"
      [disabled]="disabled"
    >
      {{ activePage - 2 }}
    </p-button>
    <p-button
    [style]="{'minWidth': '40px', 'flex': '0'}"
    variant="outlined"
    severity="contrast"
      (click)="setPage(activePage - 1)" 
      *ngIf="activePage > 1"
      [disabled]="disabled"
    >
      {{ activePage - 1 }}
    </p-button>
    <p-button
    [style]="{'minWidth': '40px', 'flex': '0'}"
    severity="info"
      class="active-btn"
      [disabled]="disabled">
      {{ activePage }}
    </p-button>
    <p-button
    [style]="{'minWidth': '40px', 'flex': '0'}"
    variant="outlined"
    severity="contrast"
      [disabled]="disabled || !itemCount"
      (click)="setPage(activePage + 1)"
      *ngIf="pageCount > 1 && activePage != pageCount"
    >
      {{ activePage + 1 }}
        </p-button>
    <p-button
    [style]="{'minWidth': '40px', 'flex': '0'}"
    variant="outlined"
    severity="contrast"
      [disabled]="disabled || !itemCount"
      *ngIf="activePage == 1 && pageCount > 2"
      (click)="setPage(activePage + 2)"
    >
      {{ activePage + 2 }}
    </p-button>
    <p-button
    [style]="{'minWidth': '40px', 'flex': '0', 'fontSize': '1.2rem'}"
    variant="outlined"  
    severity="contrast"
     (click)="setPage(activePage + 1)"
      [disabled]="disabled || !itemCount||activePage >= pageCount"
      [title]="'next_page'|translation"
    >
      <i class="fas fa-caret-right"></i>
    </p-button>
    <p-button
    [style]="{'minWidth': '40px', 'flex': '0', 'fontSize': '1.2rem'}"
    variant="outlined"
    severity="contrast"
            (click)="setPage(pageCount)"
      [disabled]="disabled || !itemCount||pageCount <= 2 || activePage >= pageCount"
      [title]="'last_page'|translation"
    >
      <i class="fas fa-forward"></i>
    </p-button>
  </p-buttongroup>
</div>
